import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";
import styleCss from "../Style/style";
import { Link, useNavigate } from "react-router-dom";
import HeaderLogo from "../img/headrlogo.png";
import SmallBus from "../img/smallbus.png";
import HeadrIcon1 from "../img/headericon1.png";
import HeadrIcon2 from "../img/headericon2.png";
// import HeadrIcon3 from "../src/img/headericon3.png";
import HeadrIcon4 from "../img/headericon4.png";
import HeadrIcon5 from "../img/headericon5.png";
import LeftMenuDrawer from "../HomeLayout/MobileMenu";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";


import AccountMenu from "../HomeLayout/DropdownLogin";

const Header = () => {
  const navigate = useNavigate();
  const isAuthenticate = useSelector((state) => state?.auth?.isAuthenticate)
  return (
    <>
      <Grid sx={styleCss.HeaderStyle}>
        <Box sx={{ display: { md: "block", xs: "none", sm: "none" } }}>
          <Container>
            <Grid container spacing={2} alignItems="center" justifyContent="space-between">
              <Grid size={{ xs: 6, md: 3 }} sx={{ display: 'flex', alignItems: 'center' }}>
                <Link to="/" style={{ marginRight: '30px' }}>
                  <img src={HeaderLogo} alt="Header Logo" style={styleCss.HeaderLogosize} />
                </Link>
                <Link to="#" style={styleCss.TicketsMenu}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center"
                    }}
                  >
                    <img src={SmallBus} alt="Small-bus" />
                    <span style={styleCss.TicketsMenu}>Bus Tickets</span>
                  </Box>
                </Link>
              </Grid>

              <Grid
                size={{ xs: 2, md: 9 }} sx={styleCss.HeaderRightSide}>
                <Stack direction="row" spacing={3} alignItems="center">
                  <Link component={RouterLink} to="/my-account" state={{ tabValue: 2 }} style={styleCss.HeaderMenustyle}>
                    <Typography>
                      <img src={HeadrIcon1} alt="" style={styleCss.IconAlignstyle} />
                      My Bookings
                    </Typography>
                  </Link>
                  <Link component={Link} to="/supportcenter" style={styleCss.HeaderMenustyle}>
                    <Typography>
                      <img src={HeadrIcon2} alt="" style={styleCss.IconAlignstyle} />
                      Supports
                    </Typography>
                  </Link>
                  {/* <Link to="/" style={styleCss.HeaderMenustyle}>
                    <Typography>
                      <img src={HeadrIcon3} alt="" style={styleCss.IconAlignstyle} />
                      Help & FAQ
                    </Typography>
                  </Link> */}
                  {isAuthenticate ?
                    <Link to="/" style={styleCss.HeaderMenustyle}>
                      <Typography>
                        <img src={HeadrIcon4} alt="" style={styleCss.IconAlignstyle} />
                        Track Bus
                      </Typography>
                    </Link> : null}
                  {isAuthenticate ?
                    <Link to="#" style={styleCss.HeaderMenustyle}>
                      <img src={HeadrIcon5} alt="" style={styleCss.IconAlignstyle1} />
                    </Link> : null}
                  {isAuthenticate ?
                    <Link to="#" onClick={(e) => e.preventDefault()} style={styleCss.HeaderMenustyle}>
                      <AccountMenu />
                    </Link> : null}
                  {isAuthenticate === false ? <Button variant="contained" sx={styleCss.LoginStyleBtn} onClick={() => navigate('/auth')}>Login</Button> : null}
                </Stack>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Box sx={{ display: { md: "none", xs: "block", sm: "block" } }}>
          <Container>
            <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center' }}>
              <Grid size={{ xs: 8, sm: 6 }}>
                <Link to="/" style={{ marginRight: '30px' }}>
                  <img src={HeaderLogo} alt="Header Logo" style={styleCss.HeaderLogosize} />
                </Link>
              </Grid>
              <Grid size={{ xs: 2, sm: 4 }} sx={{ display: 'flex', justifyContent: 'end' }}>
                <Grid sx={{ display: 'flex' }}>
                  <Grid sx={{ marginRight: '20px' }}>
                    <Link to="/" style={styleCss.HeaderMenustyle}>
                      <img src={HeadrIcon5} alt="" style={styleCss.IconAlignstyle} />
                    </Link>
                  </Grid>
                  <Grid>
                    <Link to="/" style={styleCss.HeaderMenustyle}>
                      <AccountMenu />
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 2, sm: 2 }} sx={{ textAlign: 'end' }}>
                <LeftMenuDrawer />
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Grid>
    </>
  );
};

export default Header;